import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const _11mpIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"11mp"} ref={ref}/>
});

_11mpIcon.displayName = "_11mpIcon";
